export default function PopupRowData(props: {backgroundColor?: string, children?: any, nColumns?: string, className?: string}): JSX.Element {
    const columns = props.nColumns ?? "3"
    return <div className={"md:px-8 px-6 grid grid-cols-" + columns + " py-2 bg-" + props.backgroundColor + " " + props.className}>
        {props.children}
    </div>
}